module.exports = __webpack_public_path__ + "static/WNCY_On_The_Media-0b415aece72f8e25b9eb17e42e27f979.png";